import { Component, OnInit } from '@angular/core';
import {ActivatedRoute,Router} from '@angular/router';
import {VnaPortalService} from '../../services/vna-portal.service';
import {PortalService} from '../../model/PortalService';
import {MessagingService} from '../../../../../core/service/messaging.service';
import {VnaPortalSelected} from '../../../../../core/data/messaging/VnaPortalSelected';
import {Location} from '@angular/common';

@Component({
  selector: 'app-edit-portal-service',
  templateUrl: './edit-portal-service.component.html',
  styleUrls: ['./edit-portal-service.component.scss']
})
export class EditPortalServiceComponent implements OnInit {

    portalService: PortalService;
    enabled: boolean = false;
    params: Object = {};

    constructor(private activatedRoute: ActivatedRoute,
                private router:Router,
                private portalHandler: VnaPortalService,
                private messaging: MessagingService,
                private location: Location) { }

    ngOnInit() {
        this.activatedRoute.params.subscribe(
            (params) => {
                this.params = params;
                this.enabled = true;
                this.portalHandler.findMergedPortalService(this.params['portal_pk'], this.params['service_pk']).subscribe(
                    (result) => {
                        this.portalService = new PortalService(result);
                        this.enabled = false;
                        if(!this.portalService.pkService){
                            this.router.navigateByUrl('/phone/config/portal-services')
                        }
                    }
                );
            }
        );

        //todo , encontrar manera de que todos los que escuchen el eb¡vento cambio de portal no se propague la misma accion
        this.messaging.message.subscribe(
            (result) => {
                if(result instanceof VnaPortalSelected && !result.isTheFirst() && this.location.path().match(/phone\/config\/portal/g) && !this.location.path().match(/phone\/config\/portal-services/g)){
                    this.router.navigateByUrl('/phone/config/portal/'+result.getPkPortal()+'/service/'+this.portalService.getPkService())
                }
            }
        )
    }

}



// WEBPACK FOOTER //
// /var/www/backend/src/app/phone/config/vna_portal/components/edit-portal-service/edit-portal-service.component.ts